export default {
      id: "geolocation-unavailable-usage",
      viewBox: "0 0 26 28",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#geolocation-unavailable-usage",
      toString: function () {
        return this.url;
      }
    }